import { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { http } from "../../helpers/http";
import { formatPhoneNumber } from "../../helpers/help";
import Logout from "../modals/Logout";
import RateUs from "../modals/RateUs";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import Auth from "../../auth/Auth";
import Pagination from "../pagination/Pagination";
import moment from "moment";
import OrderDetails from "../modals/OrderDetails";
import { toast } from "react-toastify";
import { clearCart, clearTipAdditionalInfo, getCartData } from "../../helpers/help";
import { COUPONS, PAYMENT } from "../../eums/messages";

const Profile = () => {
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [openOrderDetailsModal, setOpenOrderDetailsLogoutModal] = useState(false)

  // for outlet id
  const [outletId, setOutletId] = useState()

  const handleShow = () => setOpenLogoutModal(true);
  const [rateUsModal, setRateUsModal] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [orderHistory, setOrderHistory] = useState({});
  console.log(orderHistory, "orderHistory")
  const [selectedItem, setSelectedItem] = useState({});
  const [rateUs, setRateUs] = useState(false);
  // const viewCartData = localStorage.getItem("viewCartData");
  const viewCartData = sessionStorage.getItem("viewCartData");
  const [isCouponEntered, setIsCouponEntered] = useState(false);
  const { pathname } = useLocation();
  const [selectedIndexItem, setSelectedIndexItem] = useState({});
  let [searchParams] = useSearchParams();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tokn = searchParams.get('token'); // 10
  const payId = searchParams.get('PayerID');

  const getProfileData = () => {
    http(
      {
        method: "GET",
        url: `getProfile`,
        isSecure: true,
      },
      (res) => {
        if (res.error === "false") setProfileData(res.usersDetails);
        dispatch(updateFullScreenLoader(false));
      },
      (res) => { }
    );
  };

  const getOrderHistory = () => {
    dispatch(updateFullScreenLoader(true));
    let apiParams = new URLSearchParams();
    // apiParams.append("page", page);
    // apiParams.append("size", 10);
    apiParams = `?${apiParams.toString()}`;

    http(
      {
        method: "GET",
        url: `listPastOrders`,
        isSecure: true,
      },
      (res) => {
        setOutletId(res?.pastOrders[0]?.orderDetails?.outletId)
        res.error === "false" && setOrderHistory(res);
        dispatch(updateFullScreenLoader(false));
      },
      (res) => { }
    );
  };


  const handleIndexClick = (oneOrder) => {
    setOpenOrderDetailsLogoutModal(true)
    setSelectedIndexItem(oneOrder)
  }


  const getCartIds = () => {
    let cartIds = [];
    viewCartData?.dishes?.dishes.forEach((item) => {
      cartIds.push({ cartId: item.cartId });
    });

    return JSON.stringify(cartIds);
  };

  // get order confirm//// new Addition////////////////////////

  // const getOrderConfirmData = () => {
  const [commonData, setCommonData] = useState();
  useEffect(() => {
    const viewCartDataPro = JSON.parse(viewCartData);
    let cartIds = [];
    viewCartDataPro?.dishes?.dishes.forEach((item) => {
      cartIds.push({ cartId: item.cartId });
    });

    const cartIdsStr = JSON.stringify(cartIds);
    let commonDataCart = {
      outletId: viewCartDataPro?.dishes?.outletDetails?.outletId,
      udId: Auth.userInfo()?.udId,
      netAmount: viewCartDataPro?.dishes?.billTotals[viewCartDataPro?.dishes?.billTotals.length - 1]?.netAmount,
      couponName: viewCartDataPro?.couponName,
      paymentType: 11,
      cartId: cartIdsStr,
      order_type: "Take Out",
      orderSuggestions: localStorage.getItem("additionalInfo"),
      tipAmount: viewCartDataPro?.tipAmount || 0,
      donation: "No",
      donationAmount: 0.1,
      subTotalAmount: viewCartDataPro?.subTotalAmount,
      witoutCommissionPrice: viewCartDataPro?.dishes?.witoutCommissionPrice,
      gas_surcharge: viewCartDataPro?.gas_surcharge,
      subtotal_discount: viewCartDataPro?.subtotal_discount,
      delivery_discount: viewCartDataPro?.delivery_discount,
      couponSavingAmount: viewCartDataPro?.couponSavingAmount,
      delivery_fee: viewCartDataPro?.delivery_fee,
      blessings_discount: viewCartDataPro?.blessings_discount,
      order_distance: viewCartDataPro?.order_distance,
      after_discount_subtotal: viewCartDataPro?.after_discount_subtotal,
      groupPaymentAmount: "",
      token: JSON.parse(localStorage.getItem("paypalTokenWeb"))?.orderId,
      displayAmount: viewCartDataPro?.netAmount,
      isGroupOrder: "",
      // discount:viewCartDataPro?.
      method: viewCartDataPro?.payment_method_enable

    };
    if (viewCartDataPro?.payment_method_enable == "Paypal") {
      const payPalOrderID = JSON.parse(localStorage.getItem("paypalTokenWeb"))?.orderId;
      const payPalData = localStorage.getItem("paypalTokenWeb");
      commonDataCart = {
        ...commonDataCart,
        method: "paypal",
        pay_pal_order_id: payPalOrderID,
        authorization_id: searchParams.get("token"),
        payment_res_arry: !!payPalData && payPalData,
      };
    }
    setCommonData(commonDataCart)

  }, [viewCartData])


  const orderConfirm = () => {
    http(
      {
        method: "POST",
        url: "orderConfirm",
        isSecure: true,
        body: commonData && commonData,
      },
      (res) => {
        if (res.error === "false") {
          //order placed
          toast.success("Order is placed!");
          clearCart();
          clearTipAdditionalInfo();
          pathname.includes("restro-menu") ? navigate(`/restro-menu/${viewCartData?.dishes?.outletDetails?.outletId}`) : navigate("/profile")

        }
        if (res.error === "true") {
          toast.error(res.errorMessage);
        }
      }
    );
  };


  useEffect(() => {
    if (payId && tokn && commonData) {
      orderConfirm();
      // getProfileData();

      // navigate("/profile");
    }
  }, [payId, tokn, commonData]);

  useEffect(() => {
    if (!Auth.isUserAuthenticated()) {
      navigate("/");
      return;
    }
    getProfileData();
  }, [commonData]);

  useEffect(() => {
    // dispatch(updateFullScreenLoader(true));
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (commonData && Object.values(commonData).includes(undefined)) {
      return
    } else {
      getOrderHistory();
    }
  }, [commonData, rateUs]);

  useEffect(() => {
    dispatch(updateFullScreenLoader(true));
    getOrderHistory();
  }, []);


  return (
    <>
      <section className="profile">
        <div className="cus_container">
          <div className="htitile"><h4 className="head4 mb-4">Profile</h4></div>
          {!!Object.keys(profileData).length && (
            <div
              className="white_box expmainBox"

            >
              <div className="view_profile-item">
                <div className="vpi_mfDC d-flex justify-content-between">
                  <div className="Profile_info">
                    {/* <img
                      src={
                        profileData?.image
                          ? profileData?.image
                          : "./assets/img/profile.png"
                      }
                      alt="profile"
                      className="profile_img"
                    /> */}
                    <img
                      src="./assets/img/Boomerang.png"
                      alt="profile"
                      className="profile_img"
                    />
                    <div>
                      <div className="profile_name d-flex align-items-center">
                        <h5 className="head5 mb-0 me-2">
                          {profileData.userName}
                        </h5>
                        {
                          !pathname.includes("restro-menu/profile") &&
                          (<Link to="/editprofile">
                            <img
                              src="./assets/img/edit_red.svg"
                              alt="edit icon"
                            />
                          </Link>)
                        }

                      </div>
                      <div className="Profile_num d-flex align-items-center mt-2">
                        <img src="./assets/img/phone.svg" alt="edit icon" />
                        <p className="txt mb-0 ms-2 light_b">
                          {formatPhoneNumber(
                            profileData.countryCode,
                            profileData.mobileNumber
                          )}
                        </p>
                      </div>
                      <div className="Profile_num d-flex align-items-center mt-2">
                        <img src="./assets/img/iconAddtr.svg" alt="edit icon" />
                        <p className="txt mb-0 ms-2 light_b">
                          {profileData.email}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="logbtnR">
                    <div
                      className="tab-item-tr pointer"
                      onClick={handleShow}
                    >
                      <img src="./assets/img/logoutIcon.svg" alt="logout icon" />
                    </div>
                  </div>
                </div>
                <div className="profile_tab mt-lg-5 mt-4">
                  <h5 className=" me-3 head5">Order History</h5>
                </div>
              </div>
              <div
                className="gridOrdTre mt-3 row"
              >
                {orderHistory.pastOrders?.length ? (
                  orderHistory.pastOrders.map((order, index) => (
                    <div className="col-lg-4 col-md-6 mb-sm-4 mb-3">
                      <div
                        key={order.orderId}
                        className="view_profile-bg-gray"
                      >
                        <div className="restr" onClick={() => {
                          handleIndexClick(order.orderDetails)
                        }}>

                          <div className="ordercard d-flex align-items-center mb-2">
                            <img
                              src="./assets/img/ordercard.svg"
                              alt="ordercard"
                              className="me-1"
                            />

                            <span className="txt grayS text-break">
                              Order No. {order.orderDetails.displayOrderId}
                            </span>
                          </div>
                          <div className="d-flex fz14 grayS">
                            {" "}
                            <img
                              src="./assets/img/calendar_pro.svg"
                              alt="ordercard"
                              className="me-1"
                            />
                            {moment(order.displaydate).format("lll")}
                          </div>

                          <div className="d-flex align-items-center justify-content-between mt-4 mb-2">
                            <h5 className="d-inline-block head5 mb-1 blackC text-break">{order.orderDetails.outletName}
                              {/* <img
                                src="./assets/img/vegi_icon.svg"
                                alt="veg img"
                                className="ms-2"
                              /> */}

                              {/* {order?.orderDetails?.dishes?.isVeg === 1 ? (
                            <img
                              src="./assets/img/vegi_icon.svg"
                              alt="veg img"
                              className="ms-2"
                            />
                          ) : ""} */}


                            </h5>
                            {/* <p className="txt mb-0">Dish 1 x 3</p> */}
                            {/* <h5 className="head5">{order.displayNetAmount ? order.displayNetAmount.charAt(0) + Number(order.displayNetAmount.split("$")[1]).toFixed(2) : order.displayNetAmount}</h5> */}
                            {/* billCategory.displayKey == "Total" ? billCategory.displayValue.charAt(0) + Number(billCategory.displayValue.split("$")[1]).toFixed(2) : billCategory.displayValue */}
                          </div>
                          <div className="ordercard-footer">
                            <div className="loc_Dat_track d-flex flex-wrap mb-2 mb-sm-0 ">
                              <div className="d-flex fz14 my-1 my-sm-0 grayS text-break">
                                <span><img
                                  src="./assets/img/location_pro.svg"
                                  alt="ordercard"
                                  className="me-2"
                                /></span>
                                {order.orderDetails.outletAddress}
                              </div>
                              {/* <h5 className="head5 mb-0 mt-1">{order.displayNetAmount ? order.displayNetAmount.charAt(0) + Number(order.displayNetAmount.split("$")[1]).toFixed(2) : order.displayNetAmount}</h5> */}
                            </div>
                            <hr />

                          </div>
                          {order.orderDetails.dishes.map((dish, index) => (
                            <Fragment key={`${order.orderId}-${index}`}>
                              {index !== 0 && (
                                <div className="my-1"></div>
                              )}
                              <p className="txt mb-1 text-break">{dish.dishplayDish}</p>
                              {/* <p className="txt mb-1 light b">{dish.spl_instruction}</p> */}
                              {dish.customisationItems.map((aaa) => (
                                <Fragment
                                  key={`customizableName-${aaa.customizableName}`}
                                >
                                  {/* {aaa.customizableDishItems.map((bbb) => (
                                <p
                                  key={`elementId-${bbb.elementId}`}
                                  className="txt mb-1 light_b"
                                >
                                  <div className="ms-3">{bbb.elementName}</div>
                                </p>
                              ))} */}
                                </Fragment>
                              ))}
                              {/* {dish.spl_instruction ? (
                            <p className="txt mb-1 light_b">
                              <sup>*</sup>
                              {dish.spl_instruction}
                            </p>
                          ) : (
                            ""
                          )}
                          {order?.orderSuggestions &&
                            order?.orderSuggestions.trim() ? (
                            <p className="txt mb-1 light_b">
                              <sup>*</sup>
                              {order?.orderSuggestions}
                            </p>
                          ) : (
                            ""
                          )} */}
                            </Fragment>
                          ))}
                          {/* <p className="txt mb-0 light_b">
                        Qty: {order.orderDetails.displayTotalItems}
                      </p> */}

                        </div>
                        <div className="d-flex align-items-center justify-content-between">


                          <div className="d-flex align-items-center justify-content-between mt-2 w-100">
                            {/* <h5 className="head5 mb-0 ">{order.displayNetAmount ? order.displayNetAmount.charAt(0) + Number(order.displayNetAmount.split("$")[1]).toFixed(1) : order.displayNetAmount}</h5> */}
                            <h5 className="head5 mb-0 ">{order.displayNetAmount ? '$' + parseFloat(order.displayNetAmount.replace(/[^\d.-]/g, '')) : order.displayNetAmount}</h5>
                            {/* <p className="txt mb-0 light_b">

Qty: {order.orderDetails.displayTotalItems}
</p> */}
                            {(order.isdelivered === "false" &&
                              order.buttonName !== "CANCELLED") && (
                                <Link
                                  // to={`/order-status/${order.orderId}`}
                                  to={pathname.includes("restro-menu") ? `/restro-order-status/${order.orderId}` : `/order-status/${order.orderId}`}
                                  className="mb-0 cusbtn"
                                >
                                  Track Order
                                </Link>
                              )}
                          </div>
                          {(order.isdelivered === "true" && order.isRated === "false") && (
                            <span
                              className="mb-0 cusbtn"
                              onClick={() => {
                                setRateUsModal(true);
                                setSelectedItem(order);
                              }}
                            >
                              Rate Us
                            </span>
                          )}
                          {order.buttonName === "CANCELLED" && (
                            <span className="text-danger cusbtn graybtn">Rejected</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="mt-2">No Order History</p>
                )}
              </div>
              {/* 
              {orderHistory.total_page > 1 && (
                <div className="mt-4">
                  <Pagination
                    totalPages={orderHistory?.total_page}
                    currentPage={orderHistory?.current_page}
                    page={page}
                    setPage={(page) => setPage(page)}
                  />
                </div>
              )} */}
            </div>
          )}
        </div>
      </section>

      {/* modal section */}
      {/* Log out  modal*/}
      <Logout
        openLogoutModal={openLogoutModal}
        setOpenLogoutModal={setOpenLogoutModal}
        outletId={outletId}
      />

      {/* rate us modal */}
      <RateUs
        rateUsModal={rateUsModal}
        setRateUsModal={setRateUsModal}
        selectedItem={selectedItem}
        setRateUs={setRateUs}
        getOrderHistory={getOrderHistory}
      />
      <OrderDetails
        openOrderDetailsModal={openOrderDetailsModal}
        setOpenOrderDetailsLogoutModal={setOpenOrderDetailsLogoutModal}
        orderHistory={orderHistory}
        setOrderHistory={setOrderHistory}
        selectedIndexItem={selectedIndexItem}
      // setSelectedIndexItem

      />
    </>
  );
};
export default Profile;
